import { AjaxClient } from "app/common/ajax";
import { validateEmail } from "app/common/text";
import * as $ from "jquery";

export class Registration {
    private readonly ajaxClient: AjaxClient;
    private readonly ajaxLoader: string;
    private readonly ajaxSuccess: string;
    private readonly ajaxWarning: string;
    private readonly ajaxError: string;

    public constructor(
            ajaxClient: AjaxClient,
            ajaxLoader: string,
            ajaxSuccess: string,
            ajaxWarning: string,
            ajaxError: string) {
        this.ajaxClient = ajaxClient;
        this.ajaxLoader = ajaxLoader;
        this.ajaxSuccess = ajaxSuccess;
        this.ajaxWarning = ajaxWarning;
        this.ajaxError = ajaxError;

        $('#username').blur((evt) => {
            const username = $(evt.currentTarget).val() as string;
            if (username === undefined || username === null || username.length < 3 || username.length > 255) {
                $('#username-group').removeClass('form-success form-warning form-error');
                $('#username-group').addClass('form-error');
                $('#username-status').html(this.ajaxError + ' This is not a valid username.');
                return false;
            }

            $('#username-status').html(this.ajaxLoader);

            void this.ajaxClient.call<number>(`/api/user/names/${username.trim()}`, {}).then(
                (result: number) => this.onUserNameCheckResult(result),
                () => this.onUserNameCheckResult(-1)
            );
        });

        $('#email').blur((evt) => {
            const email = $(evt.currentTarget).val() as string;
            $('#email-group').removeClass('form-success form-warning form-error');

            if (validateEmail(email) && email.length <= 255) {
                $('#email-group').addClass('form-success');
                $('#email-status').html(this.ajaxSuccess);
            } else {
                $('#email-group').addClass('form-error');
                $('#email-status').html(this.ajaxError + ' This is not a valid address');
            }
        });

        $('#password').blur((evt) => {
            const password = $(evt.currentTarget).val() as string;
            $('#password-group').removeClass('form-success form-warning form-error');

            if (password.length >= 8) {
                $('#password-group').addClass('form-success');
                $('#password-status').html(this.ajaxSuccess);
            } else {
                $('#password-group').addClass('form-error');
                $('#password-status').html(this.ajaxError + ' Password must be at least eight characters long.');
            }
        });

        $('#password_confirmation').blur(() => {
            $('#password_confirmation-group').removeClass('form-success form-warning form-error');

            if ($('#password_confirmation').val() === $('#password').val()) {
                $('#password_confirmation-group').addClass('form-success');
                $('#password_confirmation-status').html(this.ajaxSuccess);
            } else {
                $('#password_confirmation-group').addClass('form-error');
                $('#password_confirmation-status').html(this.ajaxError + ' Passwords don\'t match.');
            }
        });
    }

    private onUserNameCheckResult(result: number): void {
        $('#username-group').removeClass('form-success form-warning form-error');

        if (result === 0) {
            $('#username-group').addClass('form-success');
            $('#username-status').html(this.ajaxSuccess + ' This username is available.');
        } else if (result === -1) {
            $('#username-group').addClass('form-warning');
            $('#username-status').html(this.ajaxWarning + ' Could not check username availability.');
        } else {
            $('#username-group').addClass('form-error');
            $('#username-status').html(this.ajaxError + ' This username is already in use.');
        }
    }
}
